$(document).ready(function(){

  $(".product-calculator__fieldset+.product-calculator__fieldset button, .select-plan-cta").on("click", function(){
    if($(window).width() > 1024){
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".product-form").offset().top
      }, 1000);
    }else{
//       $([document.documentElement, document.body]).animate({
//         scrollTop: $(".product-form").offset().top
//       }, 1000);
      $(".product-sticky__preview--btn").trigger("click");
    }
  });

  $(".bsub-widget__info").find(".tw-flex-shrink:first-child").find("svg").find("path").attr("stroke-width", 1);
  
  // CI Pod - Sprint 3 BY RASHMI
  $('.custom_newsletter').click(function(){
  	var _klOnsite = window._klOnsite || []; _klOnsite.push(['openForm', 'YnhgcU']);
  });
  
});